import React from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import DateHelpers from '../../lib/DateHelpers';
import { talents } from '../../lib/Talents';
import Talent from '../../lib/Talent.js';
import { updateUser } from '../../lib/Users';

class Talents extends React.Component {
  static calcStats(talents) {
    const numHigherTalents = talents.filter(talent => talent.overall_tier >= 3).length;
    const numHigherActiveTalents = talents.filter(talent => talent.overall_tier >= 3 && talent.hasAppliedRecently()).length;
    const numOverallTalents = talents.length;
    const numOverallActiveTalents = talents.filter(talent => talent.hasAppliedRecently()).length;
    const numLowerTalents = talents.filter(talent => talent.overall_tier < 3).length;
    const numLowerActiveTalents = talents.filter(talent => talent.overall_tier < 3 && talent.hasAppliedRecently()).length;
    const higherRatio = parseInt((100 * numHigherActiveTalents) / numHigherTalents, 10);
    const lowerRatio = parseInt((100 * numLowerActiveTalents) / numLowerTalents, 10);
    const overallRatio = parseInt((100 * numLowerActiveTalents) / numOverallTalents, 10);
    return [{
      higher_talent_ratio: `${higherRatio}%: ${numHigherActiveTalents} / ${numHigherTalents} `,
      lower_talent_ratio: `${lowerRatio}%: ${numLowerActiveTalents} / ${numLowerTalents} `,
      overall_talent_ratio: `${overallRatio}%: ${numOverallActiveTalents} / ${numOverallTalents} `,
    }];
  }

  static adminLinkFormatter(cell, row) {
    return `<a target="_blank" href="/users/${row.swipecast_user_id}">${cell}</a>`;
  }

  static mcLinkFormatter(cell, row) {
    return `<a target="_blank" href="${row.mc_link}">${cell}</a>`;
  }

  static dateFormatter(cell) {
    if (cell) {
      return `${Math.round(DateHelpers.differenceBetweenTimeStampsInS(Date.now(), cell) / (60 * 60 * 24))} d`;
    }
    return 'N/A';
  }


  state = {
    talents: [],
    stats: [],
  };

  componentDidMount() {
    this.getTalent();
  }

  getTalent = async () => {
    const talentList = await talents(1000, 0);
    const talentObjects = talentList.talents.map(talent => new Talent(talent));
    const stats = Talents.calcStats(talentObjects);
    this.setState({
      talents: talentObjects,
      stats,
    });
  }

  onAfterSaveCell = (row, cellName, cellValue) => {
    updateUser(
      row.swipecast_user_id,
      { admin_notes: cellValue },
    );
  }

  imageFormatter = cell => `<img style='height:100px; width:auto;' src='${cell}'/>`

  render() {
    const { stats, talents } = this.state;
    return (
      <div style={{ width: '2800px' }}>
        <BootstrapTable
          data={stats}
          striped
        >
          <TableHeaderColumn
            row="0"
            dataField="overall_talent_ratio"
            isKey
          >
            {'All models applying in last month'}
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="lower_talent_ratio"
          >
            {'Lower tier models applying in last month'}
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            dataField="higher_talent_ratio"
          >
            {'Higher tier models applying in last month'}
          </TableHeaderColumn>
        </BootstrapTable>
        <br /><br />
        <BootstrapTable
          data={talents}
          striped
          hover
          cellEdit={{
            mode: 'dbclick',
            afterSaveCell: this.onAfterSaveCell,
          }}
        >
          <TableHeaderColumn
            dataField="profile_image"
            row="0"
            rowSpan="2"
            dataFormat={this.imageFormatter}
            editable={false}
          >
            Profile Image
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="full_name"
            isKey
            dataFormat={Talents.adminLinkFormatter}
            dataAlign="center"
            dataSort
            filter={{ type: 'TextFilter', delay: 300 }}
            editable={false}
          >
              Name
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="priority"
            dataSort
            editable={false}
          >
            {'Priority?'}
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="last_activity_timestamp"
            dataSort
            dataFormat={Talents.dateFormatter}
            editable={false}
          >
              Last Active
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="let_off_waitlist"
            dataSort
            dataFormat={Talents.dateFormatter}
            editable={false}
          >
            Off Waitlist
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            colSpan="3"
            editable={false}
          >
              Tier
          </TableHeaderColumn>
          <TableHeaderColumn
            row="1"
            dataField="overall_tier"
            i
            dataAlign="center"
            dataSort
            editable={false}
            filter={{
              type: 'NumberFilter',
              delay: 1000,
              numberComparators: ['=', '>', '<='],
            }}
          >
              Overall
          </TableHeaderColumn>
          <TableHeaderColumn
            row="1"
            dataField="editorial_tier"
            i
            dataAlign="center"
            dataSort
            editable={false}
            filter={{
              type: 'NumberFilter',
              delay: 1000,
              numberComparators: ['=', '>', '<='],
            }}
          >
            Editorial
          </TableHeaderColumn>
          <TableHeaderColumn
            row="1"
            dataField="commercial_tier"
            i
            dataAlign="center"
            dataSort
            editable={false}
            filter={{
                type: 'NumberFilter',
                delay: 1000,
                numberComparators: ['=', '>', '<='],
            }}
          >
            Commercial
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="mc_link"
            editable={false}
            dataFormat={Talents.mcLinkFormatter}
            dataSort
          >
            MC Link
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataSort
            editable={false}
            dataField="number_of_applications"
          >
            # Jobs Applied
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataSort
            editable={false}
            dataField="number_of_conversations"
          >
            # Convos
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            dataField="most_recent_application"
            dataSort
            editable={false}
            dataFormat={Talents.dateFormatter}
          >
            Last Job Applic.
          </TableHeaderColumn>
          <TableHeaderColumn
            row="0"
            rowSpan="2"
            width="50%"
            dataField="admin_notes"
            tdStyle={{ whiteSpace: 'normal' }}
          >
            Admin notes
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default Talents;
